import { useContext, useEffect, useState } from "react";
import { serverLine } from "../../../../../controllers/network/serverLine";
import DropDownInput from "../../../../helperComponents/DropDownInput";
import Context from "../../../../../Context";
import { useTranslation } from "react-i18next";

export default function DropDownCategories({ value, onChange }) {
  const { adminSettings } = useContext(Context);

  const { t } = useTranslation();

  if (!adminSettings) return null;
  if (!adminSettings.data) return null;
  if (!adminSettings.data.categories) return null;

  return (
    <DropDownInput
      // style={{ background: "var(--surface)" }}
      label={t("shoppingPageFilterLabel")}
      placeholder={t("shoppingPageFilterPlaceholder")}
      value={value}
      onChange={onChange}
      options={adminSettings.data.categories.map((item) => getItem(item))}
    />
  );

  function getItem(item) {
    return {
      onClick: () => {
        onChange(item._id);
      },
      value: item._id,
      isSelected: value === item._id,
      label: `${item.name}`,
    };
  }
}
